import SelectBoxSingle from "./SelectBoxSingle";

export type { ISelectBoxSingleItem } from "./SelectBoxSingle";
export default SelectBoxSingle;
